import { doc, getDoc } from "firebase/firestore";
import { auth, db, functions } from "../../firebase/firebase";
import { nameofTutorCredentialsSchemaCollection, TutorCredentialsSchema, TutorCredentialsView } from "../Types/TutorCredentialsSchema";
import { httpsCallable } from "firebase/functions";
import { createWWCCRequest } from "./requestFunction";

export async function getTutorCredentials(tutorID: string): Promise<TutorCredentialsView | undefined> {
    const tutorCredentialsRef = doc(db, nameofTutorCredentialsSchemaCollection, tutorID);
    var tutorCredentials = await getDoc(tutorCredentialsRef);
    if (tutorCredentials.exists()) {
        return {
            Id: tutorCredentials.id,
            WWCC: tutorCredentials.data().WWCC,
            WWCCverified: tutorCredentials.data().WWCCverified,
        } as TutorCredentialsView;
    } else {
        await createTutorCredentials();
    }
    tutorCredentials = await getDoc(tutorCredentialsRef);
    if (tutorCredentials.exists()) {
        return {
            Id: tutorCredentials.id,
            WWCC: tutorCredentials.data().WWCC,
            WWCCverified: tutorCredentials.data().WWCCverified,
        } as TutorCredentialsView;
    }
    return undefined;
}

export async function updateTutorCredentialsWWCC(tutorCredential: TutorCredentialsSchema): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }

    await createWWCCRequest(tutorCredential.WWCC);
    
    const updateTutorCredentials = httpsCallable(functions, "updateTutorCredentialWWCC");

    await updateTutorCredentials({ WWCC: tutorCredential.WWCC }).catch((error) => {
        throw new Error(error);
    });
}

export async function createTutorCredentials(): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }
    
    const createTutorCredentials = httpsCallable(functions, "createTutorCredential");

    await createTutorCredentials().catch((error) => {
        throw new Error(error);
    });
}